<template>
    <div>
        <b-row>
            <b-col cols="12" md="6">
                <b-card>
                    <app-stacked-bar
                        title="1. Visitas de personas por tipo de visitante"
                        v-if="!!personEntryChartData.length"
                        :chart-data="personEntryChartData"
                    />
                </b-card>
                <b-alert variant="success" v-if="!personEntryChartData.length" show>No hay datos</b-alert>
            </b-col>
            <b-col cols="12" md="6">
                <b-card>
                    <app-stacked-bar
                        title="2. Visitas de vehículos por tipo de visitante"
                        v-if="!!vehicleEntryChartData.length"
                        :chart-data="vehicleEntryChartData"
                    />
                </b-card>
                <b-alert variant="success" v-if="!vehicleEntryChartData.length" show>No hay datos</b-alert>
            </b-col>
            <b-col cols="12" md="6">
                <b-card>
                    <app-stacked-bar
                        title="3. Minutas por tipo de anotación"
                        v-if="!!notebookChartData.length"
                        :chart-data="notebookChartData"
                    />
                </b-card>
                <b-alert variant="success" v-if="!notebookChartData.length" show>No hay datos</b-alert>
            </b-col>
            <b-col cols="12" md="6">
                <b-card>
                    <app-stacked-bar
                        title="4. Correspondencia recibida por tipo"
                        v-if="!!mailsChartData.length"
                        :chart-data="mailsChartData"
                    />
                </b-card>
                <b-alert variant="success" v-if="!mailsChartData.length" show>No hay datos</b-alert>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import StackedBar from '../../../Charts/StackedBar.vue';
import reportingRepository from '../../../../../repositories/reporting.repository.js';
export default {
    components: {
        appStackedBar: StackedBar
    },

    props: {
        clientId: {
            required: true
        }
    },

    data(){
        return {
            personEntryData: [],
            vehicleEntryData: [],
            notebookData: [],
            mailsData: [],
            dutiesData: []
        }
    },

    watch: {
        clientId(val){
            this.loadAdoptionData();
        }
    },
    
    computed: {
        personEntryChartData(){
            if(!this.personEntryData.length) return [];

            const types = __.uniq(__.pluck(this.personEntryData, 'type'));
            const periods = __.uniq(__.pluck(this.personEntryData, 'period'));

            const series = [];
            
            periods.map(period => {
                
                const serieData = [];
                const serie = [period];
                types.map(type => {
                    
                    let entry = this.personEntryData.find(item => item.period === period && item.type === type);
                    let val = !!entry && !!entry.visits?entry.visits: 0;
                    serie.push(val);
                    
                });
                serie.push('');

                series.push(serie);
            })
            
            const header = ['Tipo Visitante', ...types, { role: 'annotation' }];
            const data = [header, ...series];

            return data;
        },
        vehicleEntryChartData(){
            if(!this.vehicleEntryData.length) return [];

            const types = __.uniq(__.pluck(this.vehicleEntryData, 'type'));
            const periods = __.uniq(__.pluck(this.vehicleEntryData, 'period'));

            const series = [];
            
            periods.map(period => {
                
                const serieData = [];
                const serie = [period];
                types.map(type => {
                    
                    let entry = this.vehicleEntryData.find(item => item.period === period && item.type === type);
                    let val = !!entry && !!entry.visits?entry.visits: 0;
                    serie.push(val);
                    
                });
                serie.push('');

                series.push(serie);
            })
            
            const header = ['Tipo Visitante', ...types, { role: 'annotation' }];
            const data = [header, ...series];

            return data;
        },
        notebookChartData(){
            if(!this.notebookData.length) return [];

            const types = __.uniq(__.pluck(this.notebookData, 'type'));
            const periods = __.uniq(__.pluck(this.notebookData, 'period'));

            const series = [];
            
            periods.map(period => {
                
                const serieData = [];
                const serie = [period];
                types.map(type => {
                    
                    let notebook = this.notebookData.find(item => item.period === period && item.type === type);
                    let val = !!notebook && !!notebook.notebook?notebook.notebook: 0;
                    serie.push(val);
                    
                });
                serie.push('');

                series.push(serie);
            })
            
            const header = ['Tipo Visitante', ...types, { role: 'annotation' }];
            const data = [header, ...series];

            return data;
        },
        mailsChartData(){
            if(!this.mailsData.length) return [];

            const types = __.uniq(__.pluck(this.mailsData, 'type'));
            const periods = __.uniq(__.pluck(this.mailsData, 'period'));

            const series = [];
            
            periods.map(period => {
                
                const serieData = [];
                const serie = [period];
                types.map(type => {
                    
                    let mails = this.mailsData.find(item => item.period === period && item.type === type);
                    let val = !!mails && !!mails.mailsReceived?mails.mailsReceived: 0;
                    serie.push(val);
                    
                });
                serie.push('');

                series.push(serie);
            })
            
            const header = ['Tipo Visitante', ...types, { role: 'annotation' }];
            const data = [header, ...series];

            return data;
        },
        dutiesChartData(){
            if(!this.dutiesData.length) return [];

            const types = __.uniq(__.pluck(this.vehicleEntryData, 'type'));
            const periods = __.uniq(__.pluck(this.vehicleEntryData, 'period'));

            const series = [];
            
            periods.map(period => {
                
                const serieData = [];
                const serie = [period];
                types.map(type => {
                    
                    let entry = this.vehicleEntryData.find(item => item.period === period && item.type === type);
                    let val = !!entry && !!entry.visits?entry.visits: 0;
                    serie.push(val);
                    
                });
                serie.push('');

                series.push(serie);
            })
            
            const header = ['Tipo Visitante', ...types, { role: 'annotation' }];
            const data = [header, ...series];

            return data;
        },
    },
    methods: {
        loadAdoptionData(){
            const rr = {...reportingRepository};
            rr.loadAdoptionData(this.clientId)
            .then(data => {
                this.personEntryData = data.personEntryData;
                this.vehicleEntryData = data.vehicleEntryData;
                this.notebookData = data.notebookData;
                this.mailsData = data.mailsData;
            })
            .catch(error => toastr.error('Ocurrio un error al cargar la informacion del reporte de adopcion'));
        },
        initialize(){
            this.loadAdoptionData();
        }
    },
    created(){
        this.initialize();
    }
}
</script>

<style>

</style>
